import { render } from "./IdentityCard.vue?vue&type=template&id=8d27c1c6&scoped=true&ts=true"
import script from "./IdentityCard.vue?vue&type=script&lang=ts"
export * from "./IdentityCard.vue?vue&type=script&lang=ts"

import "./IdentityCard.vue?vue&type=style&index=0&id=8d27c1c6&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d27c1c6"]])

export default __exports__